/* eslint-disable */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

const TextField = ((props, ref) => {
  const { label, placeholder, required, readOnly, type, name, error, defaultValue, onChange, step, action, tooltiptext, key1 } = props;
  const [showPassword, setShowPassword] = useState(false); 
  const [tooltipFlag, setShowTooltip] = useState(false);
  const hexValArr = ['matterProductId', 'commissioningHint1', 'commissioningHint2', 'availableMaxVer', 'availableMinVer', 'cdVersion', 'majorVersion', 'productId'];

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div style={{ position: 'relative' }}>
      {error?true:false}
      <se-form-field
        label={label}
        option='inline'
        block
        label-align='left'
        required={required}
        data-testid='textfield'
        disabled={readOnly}
        status={error?"error":""}
        style={{ marginLeft: 0 }}
      >
       {action? <span className='labelIcon' onMouseEnter={() => setShowTooltip(true)} onMouseLeave= {() => setShowTooltip(false)}><se-tooltip position='top' color='information'><se-icon slot='trigger' option='raised'>{action}</se-icon>
        {tooltipFlag && (<div>{tooltiptext}</div>)}
        </se-tooltip></span> : null}
        <div style={{ display: 'flex',alignItems: 'center' }}>
          {type !== 'decimal' && <input
            placeholder={type === 'password' ? '********' : placeholder}
            type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
            name={name}
            data-testid='input'
            className={type == 'number'? 'removeSpin' : null}
            value={hexValArr.includes(key1) && defaultValue && readOnly ? defaultValue + ' (0x' + Number(defaultValue).toString(16).toUpperCase() + ')' : defaultValue ? defaultValue : '' }
            onChange={(e)=> onChange(e.target.value, name)}
          />}
          
          {type == 'decimal' && <input
            placeholder={placeholder}
            type={type}
            step={step}
            name={name}
            pattern="\d\.\d{2}"
            title='Please enter version in the correct format x.xx'
            data-testid='input'
            value={defaultValue ? defaultValue : ''}
            onChange={(e) => onChange(e.target.value, name)}
          />}
          {type === 'password' && (
            <span
              onClick={handleClickShowPassword}
              data-testid='spanClick'
              style={{ position: 'absolute', right: '1%' }}
            >
              {showPassword ? <se-icon>body_eye</se-icon> : <se-icon>eye_dont_show</se-icon>}
            </span>
          )}
        </div>
      </se-form-field>
      {error && (<span className='errorMsg'>{error}</span>)}
    </div>
  );
});

export default TextField;

TextField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  handleClickShowPassword: PropTypes.func,
  handleInputChange: PropTypes.func,
  required: PropTypes.bool.isRequired,
  error: PropTypes.string,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  handleEvent: PropTypes.func,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func
};

TextField.defaultProps = {
  defaultValue: null,
};
